import { render, staticRenderFns } from "./EraStatus.vue?vue&type=template&id=62ed9d48&"
import script from "./EraStatus.vue?vue&type=script&lang=js&"
export * from "./EraStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports